import * as a from '../actions'

const initialState = ({ title, primary_color, secondary_color, element_color,
  element_text_color, element_secondary_color, element_secondary_text_color,
  xxxhdpi, updated_at } = {}) => ({
    title: title || '',
    primary_color: primary_color || '#082966',
    secondary_color: secondary_color || '#FF9933',
    element_color: element_color || '#f79410',
    element_text_color: element_text_color || '#ffffff',
    element_secondary_color: element_secondary_color || '#2c2e52',
    element_secondary_text_color: element_secondary_text_color || '#ffffff',
    xxxhdpi: xxxhdpi || 'https://badgeheroes-owned-rateinc.s3.amazonaws.com/logos/3/xxxhdpi/Logo_transparente-01.png',
    updated_at: updated_at || '',
  }
)

const updateLayout = (state = initialState(), { type, payload }) => {
  switch (type) {

    case a.SETTINGS_SUCCEEDED:
      return { ...state, ...initialState(payload) }
    case a.SETTINGS_FAILED:
      return state
    default:
      return { ...state }
  }
}

export default updateLayout




// WEBPACK FOOTER //
// ./src/reducers/layout.jsx